import { min } from "lodash";

/* istanbul ignore file */
const state = {
    contract: {
        id:null,
        text: null,
    },
    userContract: {
        name: null,
        cpf: null,
        email: null,
        contractTermosUsoId: null,
        ownerCpfCnpj: null,
        ownerName: null
    }
};
const mutations = {
    setContract(st, contract) {
        st.contract = {
            id: contract.id,
            text: contract.text,
        }
    },
    setUserContract(st, userContract) {
        st.userContract = userContract;
    }
};
const getters = {
    getContractText(st) {
      return st.contract.text;
    },
    getContractId(st) {
        return st.contract.id;
    },
    getUserContract(st) {
        return st.userContract;
    }
  };
const actions = {
    async findContract({ dispatch, commit, rootState }) {
        const onError = (error) => {
            console.log(error)
            this.$notify('Erro ao carregar contrato.');
        };
        try {
            await dispatch('contractText/get', {method: 'get'}, { root: true });
            const contractResult = rootState.contractText.copy
            if (contractResult.status === 100) {
                commit('setContract', contractResult.ret);
            } else {
                onError();
            }
        } catch (e) {
            onError(e);
        }
    },
    async findUserContract({commit, dispatch, rootState}, {email, onSuccess, onError}) {
        try {
            await dispatch('contract/get', email, { root: true });
            const contractResult = rootState.contract.copy
            console.info(contractResult);
            if (contractResult.status === 100) {
                commit('setUserContract', contractResult.ret);
                console.info(contractResult.ret);
                onSuccess()
            } else {
                onError();
            }
        } catch (e) {
            console.info(e)
            onError();
        }
    },
    async createUserContract({dispatch, rootState}, {username, password, onSuccess, onError}) {
        try {
            const user = rootState.users.copy
            const contract = rootState.contractText.copy
            const mineAccounts = await dispatch('accounts/find', { query: { userOwnerId: user.id } }, { root: true });
            const otherAccounts = await dispatch('accounts/find', { query: { guestId: user.id } }, { root: true });
            const currentAccount = [...mineAccounts, ...otherAccounts][0]

            const data = {
                name: user.name,
                cpf: user.cpf,
                email: username,
                contractTermosUsoId: contract.ret.id,
                ownerCpfCnpj: currentAccount.cpfCnpjOwner,
                ownerName: currentAccount.name,
                urlAuth: `${process.env.VUE_APP_GATEWAY_URI}/tokens?username=${username}&password=${password}`
            }

            await dispatch('contract/create', {data}, { root: true });
            onSuccess()
        } catch (e) {
            onError(e);
        }
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
